import { createAction, union } from '@ngrx/store';
import { UserProfile } from 'src/app/models/user-profile/user-profile';
import { LoadingState } from '../restaurant/restaurant.reducer';

export const storeUserProfile = createAction(
  'UserProfileActions storeUserProfile',
  (payload: UserProfile) => ({ payload }),
);

export const clearUserProfile = createAction(
  'UserProfileActions clearUserProfile',
);

export const updateLoadingState = createAction(
  'UserProffileActions updateLoadingState',
  (payload: LoadingState) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'UserProffileActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const storeSuccessMessage = createAction(
  'UserProffileActions storeSuccessMessage',
  (payload: string) => ({ payload }),
);

const all = union({
  storeUserProfile,
  clearUserProfile,
  updateLoadingState,
  storeErrorMessage,
  storeSuccessMessage,
});
export type UserProfileActionsUnion = typeof all;
